<template>
    <div class="logo-wrap">
      <div><img :src="logo" alt=""></div>
      <div class="line"></div>
      <div><span>{{config.registeredServiceName||'统一身份认证'}}</span></div>
    </div>
</template>
<script>
export default {
  props: [
    'i18n',
    'config',

    'logo'
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
    
  },
  mounted: function mounted() {
    // this.$nextTick(()=>{
    //   console.log(this.$refs.svgColor)
    //   this.$refs.svgColor.style.filter = 'drop-shadow(#ff0000 30px 0 0)'
    //   this.$refs.svgColor.style.height = '50px'
    // })
  },
  methods:{
  }
}
</script>
